import React, { Component } from 'react';
import Preloader from '../img/preloader.gif';
import Api from '../config/Api';

class ForgotPassword extends Component {
	constructor(props) {
		super(props);
		this.state = {
			recoveryEmail: '',
			recoveryResponse: '',
			isLoading: false,
			showPreloader: false
		}
	}

	onSubmitPasswordRecovery = (event) => {
		var self = this;
		event.preventDefault();
		this.setState({
			isLoading: true,
			showPreloader: true,
			recoveryResponse: ''
		}, function() {
			Api.passwordRecovery(JSON.stringify({ email: this.state.recoveryEmail }), function(response) {
				self.setState({
					recoveryResponse: response.recoveryResponse,
					showPreloader: response.showPreloader,
				}, function() {
					if(response.errorCode === 1) {
						self.setState({
							isLoading: false
						});
					}
				});
			});
		});
	}

	onChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		});
	}

    render() {
        return(
            <div className="home">
            	<div className="homeCtr br10 sh1 passwordRecovery">
            		<h2 className="br10Top">Password Recovery</h2>
            		<div className="info">
            			<form onSubmit={this.onSubmitPasswordRecovery}>
							<input type="text" name="recoveryEmail" className="input1 br5 anim1" placeholder="E-mail address" onChange={this.onChange} />
							<input type="submit" className="submit1 br5 anim1" value="Send me instructions" disabled={this.state.isLoading} />
							<p className="response">{this.state.recoveryResponse}</p>
							<img className="preloader" src={Preloader} alt="Fresenius Preloader" style={{display: (this.state.showPreloader ? 'block' : 'none')}} />
						</form>
            		</div>
            	</div>
            </div>
        );
    }
}

export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/components/ForgotPassword.js